(() => {
  const ROOT_SELECTOR = '[data-panel-quilt]';
  const SLOT_SELECTOR = '[data-panel-slot]';

  const shuffle = (items) => {
    const copy = items.slice();
    for (let index = copy.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [copy[index], copy[randomIndex]] = [copy[randomIndex], copy[index]];
    }
    return copy;
  };

  const imageSource = (product) => {
    if (!product) return '';
    if (Array.isArray(product.images) && product.images.length) {
      const image = product.images[0];
      if (typeof image === 'string') return image;
      return image && (image.src || image.url) || '';
    }
    if (typeof product.featured_image === 'string') return product.featured_image;
    return product.featured_image && (product.featured_image.src || product.featured_image.url) || '';
  };

  const isUsefulPanel = (product) => {
    if (!product || !product.handle || !imageSource(product)) return false;
    const title = String(product.title || '').toLowerCase();
    return !/(book|pattern|mashup|quilt kit)/.test(title);
  };

  const fetchPage = async (root, handle, page) => {
    const response = await fetch(`${root}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Panel request failed: ${response.status}`);
    const payload = await response.json();
    return Array.isArray(payload.products) ? payload.products : [];
  };

  const load = async (section) => {
    if (!section || ['loading', 'loaded'].includes(section.dataset.panelQuiltStatus)) return;
    const handle = section.dataset.collectionHandle;
    const slot = section.querySelector(SLOT_SELECTOR);
    if (!handle || !slot) return;
    section.dataset.panelQuiltStatus = 'loading';

    const routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const root = routeRoot || '/';
    const count = Number.parseInt(section.dataset.productCount, 10) || 250;
    const maxPage = Math.max(1, Math.ceil(count / 250));
    const page = 1 + Math.floor(Math.random() * maxPage);

    try {
      let products = (await fetchPage(root, handle, page)).filter(isUsefulPanel);
      if (!products.length && page !== 1) products = (await fetchPage(root, handle, 1)).filter(isUsefulPanel);
      const product = shuffle(products)[0];
      const image = slot.querySelector('[data-panel-image]');
      const title = slot.querySelector('[data-panel-title]');
      if (!product || !image) {
        section.dataset.panelQuiltStatus = 'empty';
        return;
      }

      const source = imageSource(product);
      const reveal = () => slot.classList.add('is-loaded');
      image.addEventListener('load', reveal, { once: true });
      image.src = source;
      image.alt = product.title || 'Fabric panel';
      image.decoding = 'async';
      slot.href = `${root}products/${encodeURIComponent(product.handle)}`;
      slot.setAttribute('aria-label', `View ${product.title || 'fabric panel'}`);
      if (title) title.textContent = product.title || 'Fabric panel';
      if (image.complete) reveal();
      section.dataset.panelQuiltStatus = 'loaded';
    } catch (error) {
      section.dataset.panelQuiltStatus = 'error';
      console.warn('Random quilt panel could not be loaded.', error);
    }
  };

  const initialize = (scope = document) => {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) load(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(ROOT_SELECTOR).forEach(load);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();